import { useState, useEffect } from 'react'
import { useQuery } from './useQuery'
import storageService from '../services/storageService'

export const useUserStatuses = (updateUser) => {
  const [user, setUser] = useState(storageService.getUser())

  const shouldFetch = ['PROCESSING', 'REQUIRED'].includes(user.national_id_status)

  const { data: response, isLoading } = useQuery('/user/capabilities', {
    condition: shouldFetch,
    errorRetryCount: 5,
    errorRetryInterval: 1000,
  })

  useEffect(() => {
    if (response?.data) {
        const { deposit, national_id_status } = response.data.data

      setUser(currentUser => {
        const updatedUser = {
          ...currentUser,
          national_id_status,
          user_capabilities: {
            ...currentUser?.user_capabilities,
            deposit,
          },
        } 

        updateUser(updatedUser)
        return updatedUser
      })
    }
  }, [response, updateUser])

  return { user, isLoading }
}
